import { Component, Inject, Input, OnChanges, EventEmitter, Output, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../utils/utils";
import { TableFixedHeaderSearchComponent } from "../table/table-fixed-header-search.component";
import { DialogService } from "../../services/dialog.service";
import { SaveService } from "../../services/save.service";
import { DefaultValuesService } from "../../services/defaultvalues.service";

@Component({
    selector: "maintenance-control-plan-group-action-list",
    templateUrl: './mcp-list-group-action.component.html',
    styleUrls: ['../../style/list.component.less', './mcp-list.component.less'],
    standalone: false
})

export class MaintenanceControlPlanGroupActionListComponent implements OnInit {
    @Input('list') list: MaintenanceControlPlanGroupAction[] = [];
    @Input() mcpgroup: MaintenanceControlPlanGroup = <MaintenanceControlPlanGroup>{};
    @Input() newService: SaveService | undefined;

    //innerList: TableFixedHeaderSearchComponent | undefined;

    header: any[] = [
        { label: 'Action', show: true, searchtype: 'text' }
        , { label: 'Components Count', show: true, searchtype: 'number' }
    ];

    expanded: boolean[] = [];    
    newChildService: SaveService | undefined;

    //expandList: MaintenanceControlPlanGroupActionComponent[] = [];

    constructor(
        private router: Router
        , private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , private dialog: DialogService
        , public defaults: DefaultValuesService
    ) {
    }

    /**
     * this is from who calls (inner component)
     * @param list
     * @param row
     * @param column
     */
    getData(list: MaintenanceControlPlanGroupAction[], row: number, column: number): string {
        if (list) {
            var e = list[row];
            switch (column) {
                case 0:
                    return e.ActionDescription;
                default:
                    return e.NUMBER_COMPONENTS != null ? e.NUMBER_COMPONENTS.toString() : "";
            }
        }
        else
            return "";
    }

    ngOnInit() {
        this.dialog.tthis = this;
        this.newChildService = new SaveService();
        this.newChildService.addListener(this);

    }

    onDelete(value: { index: number, value: MaintenanceControlPlanGroupAction }) {
        this.dialog.showConfirmDialog(value.value.ActionDescription + "(" + value.value.MCPActionID + ")?", "Delete MCP Group Action", this, value);
    }

    onExpand(value: any) {
        if (value.expanded) {

            Utils.httpAllGetMaintenanceControlPlanGroupActionComponents(
                this.http
                , this.baseUrl
                , value.value.MCPActionID
                , this
                , function (tthis: any, list: MaintenanceControlPlanGroupActionComponent[]) {
                    tthis.list[value.index].Components = list;
                }
            )
        }
    }

    onNewChild(value: { index: number, value: MaintenanceControlPlanGroupAction }) {
        if (this.newChildService)
            this.newChildService.fireNew();
    }

    onYes(value: { index: number, value: MaintenanceControlPlanGroupAction }) {
        this.http
            .delete<MaintenanceControlPlanGroupAction>(
                this.baseUrl + Utils.getMaintenanceControlPlanAPI() + "groupaction/" + value.value.MCPActionID
            )
            .subscribe(
                res => this.list.splice(value.index, 1)
                , error => this.dialog.showErrorDialog(error)
        );
    }
}